import { Card, CardBody, Col } from "reactstrap";
import { HorizontalDashedDividerTitle } from "../../../Constants/Constants";
import { HorizontalDashedDividerData, HorizontalDashedDividerSubTitle } from "../../../Data/UiKits/Divider";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const HorizontalDashedDivider = () => {
  return (
    <Col xxl="4" md="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={HorizontalDashedDividerTitle} span={HorizontalDashedDividerSubTitle} />
        <CardBody className="main-divider">
          {HorizontalDashedDividerData.map((item, index) => (
            <div className={`divider-body divider-body-2 divider-${item.color}`} key={index}>
              <div className={`divider-circle bg-light-${item.color}`}>
                <i className={`fa fa-${item.icon} txt-${item.color}`} />
              </div>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default HorizontalDashedDivider;
